<!--
 * @Author: 月魂
 * @Date: 2021-11-28 15:15:15
 * @LastEditTime: 2021-12-07 14:12:33
 * @LastEditors: 月魂
 * @Description: 开屏页
 * @FilePath: \seven-silk\src\views\Index.vue
-->
<template>
  <div class="container" ref="box">
    <img src="http://image.wearetogether.com.cn/seven-silk-poster.png" alt="" class="poster">
    <div class="tang" @click="jumpToDetail(tang)">唐吉坷德</div>
    <div class="hu" @click="jumpToDetail(hu)">胡桃夹子</div>
    <div class="ling" @click="jumpToDetail(ling)">灵魂之光</div>
    <div class="hai" @click="jumpToDetail(hai)">海盗</div>
    <div class="jump" @click="jumpToDetail(jump)">jump</div>
    <div class="can" @click="jumpToDetail(can)">灿烂</div>
    <div class="nu" @click="jumpToDetail(nu)">奴道成寺</div>
    <div class="fo" @click="jumpToDetail(fo)">佛陀</div>
    <div class="break" @click="jumpToDetail(tu)">突破边界</div>
    <div class="piano" @click="jumpToDetail(piano)">贝多芬钢协</div>
    <div class="light" @click="jumpToDetail(light)">照亮世界</div>
    <div class="nigula" @click="jumpToDetail(nigula)">尼古拉</div>
    <div class="flower" @click="jumpToDetail(flower)">大地花开</div>
    <div class="terra" @click="jumpToDetail(terra)">秦兵马俑</div>
    <div class="bread" @click="jumpToDetail(bread)">一块面包的秘密</div>
    <div class="lu" @click="jumpToDetail(lu)">路遥</div>
    <div class="zhou" @click="jumpToDetail(zhou)">周仁</div>
    <div class="bread2" @click="jumpToDetail(bread)">一块面包的秘密2</div>
    <div class="jiangshan" @click="jumpToDetail(jiangshan)">江山多娇</div>
    <div class="jiaoyang" @click="jumpToDetail(jiao)">骄杨之恋</div>
    <div class="tiane" @click="jumpToDetail(tian)">天鹅湖</div>
    <div class="bread3" @click="jumpToDetail(bread)">一块面包的秘密3</div>
    <div class="sichou" @click="jumpToDetail(silk)">丝绸之路国际艺术作品展</div>
    <div class="zhangqian" @click="jumpToDetail(zhang)">张骞</div>
    <div class="bread4" @click="jumpToDetail(bread)">一块面包的秘密4</div>
    <div class="bread5" @click="jumpToDetail(bread)">一块面包的秘密5</div>
    <div class="out" @click="jumpToDetail(out)">出长安</div>
    <div class="river" @click="jumpToDetail(river)">大河上下</div>
    <div class="red" @click="jumpToDetail(red)">红色娘子军</div>
    <div class="pina" @click="jumpToDetail(pina)">皮娜</div>
    <div class="chai" @click="jumpToDetail(chai)">柴可夫斯基</div>
    <div class="big" @click="jumpToDetail(big)">丝路大河颂</div>
    <div class="changan" @click="jumpToDetail(changan)">风华长安</div>
    <div class="qin" @click="jumpToDetail(qin)">秦腔</div>
    <div class="hua" @click="jumpToDetail(hua)">陕西话剧主旨论坛</div>
    <div class="cul" @click="jumpToDetail(cul)">疫情下思路文化</div>
    <div class="suiyue" @click="jumpToDetail(suiyue)">岁月韶华</div>
    <div class="bread6" @click="jumpToDetail(bread)">一块面包的秘密6</div>
    <button class="btn" @click="$router.push('/home')">Enter</button>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'Index',
  data() {
    return {
      tang: { type: 'perform', linkId: 10 },
      hu: { type: 'perform', linkId: 22 },
      ling: { type: 'perform', linkId: 13 },
      hai: { type: 'perform', linkId: 15 },
      jump: { type: 'perform', linkId: 24 },
      can: { type: 'perform', linkId: 20 },
      nu: { type: 'perform', linkId: 9 },
      fo: { type: 'perform', linkId: 21 },
      tu: { type: 'perform', linkId: 25 },
      piano: { type: 'perform', linkId: 14 },
      light: { type: 'perform', linkId: 16 },
      nigula: { type: 'perform', linkId: 23 },
      flower: { type: 'exhibition', linkId: 4 },
      terra: { type: 'exhibition', linkId: 5 },
      bread: { type: 'perform', linkId: 4 },
      lu: { type: 'perform', linkId: 7 },
      zhou: { type: 'perform', linkId: 11 },
      jiangshan: { type: 'exhibition', linkId: 3 },
      jiao: { type: 'perform', linkId: 18 },
      tian: { type: 'perform', linkId: 19 },
      silk: { type: 'exhibition', linkId: 2 },
      zhang: { type: 'perform', linkId: 1 },
      out: { type: 'exhibition', linkId: 6, time: '2021-12-01 23:59:59', title: '出长安' },
      river:  { type: 'exhibition', linkId: 1, time: '2021-11-28 23:59:59', title: '大河上下' },
      pina: { type: 'perform', linkId: 8, title: '皮娜', time: '2021-12-02 23:59:59' },
      chai: { type: 'perform', linkId: 17, title: '「20影像——交响之声」法国巴黎管弦乐团 柴可夫斯基第一钢协与柏辽兹幻想交响曲', time: '2021-12-05 23:59:59' },
      red: { type: 'perform', linkId: 5, title: '红色娘子军', time: '2021-12-01 23:59:59' },
      big: { type: 'perform', linkId: 2, title: '丝路大河颂', time: '2021-11-29 23:59:59' },
      changan: { type: 'perform', linkId: 3, title: '风华长安', time: '2021-11-30 23:59:59' },
      qin: { type: 'perform', linkId: 6, title: '秦腔', time: '2021-12-01 23:59:59' },
      cul: { type: 'forum', linkId: 2, title: '疫情下丝路文化实景演艺创新发展论坛', time: '2021-12-03 23:59:59' },
      hua: { type: 'forum', linkId: 1, title: '陕西话剧现象主旨论坛', time: '2021-12-22 23:59:59' },
      suiyue: { type: 'perform', linkId: 12, title: '民族歌舞剧《岁月韶华》', time: '2021-12-04 23:59:59' }
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.$refs.box.scrollLeft = 540
    })
    
  },
  methods: {
    jumpToDetail(params) {
      if (params instanceof Array) {
        // 计算数组内时间进行跳转
        // 跳转规则，判断每个元素演出时间，跳转对应项目（超过演出项目时间则跳转下个项目，若集合内全部项目已过期则显示最后一个项目）
        const lastItem = params[params.length - 1];
        if (dayjs().isAfter(lastItem.time)) {
          this.$router.push(`/${lastItem.type}-detail/${lastItem.linkId}`)
        } else {
          const index = params.findIndex(item => dayjs().isBefore(item.time));
          this.$router.push(`/${params[index].type}-detail/${params[index].linkId}`)
        }
      } else {
        // 直接跳转到对应的内容
        this.$router.push(`/${params.type}-detail/${params.linkId}`)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  overflow: auto;
  position: relative;
  font-size: 12px;
  .poster {
    display: block;
    height: 1000px;
  }
  .tang {
    width: 180px;
    height: 20px;
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    top: 14px;
    left: 160px;
    opacity: 0;
  }
  .hu {
    width: 180px;
    height: 20px;
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    top: 36px;
    left: 160px;
    opacity: 0;
  }
  .ling {
    width: 180px;
    height: 20px;
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    top: 58px;
    left: 160px;
    opacity: 0;
  }
  .hai {
    width: 180px;
    height: 20px;
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    top: 80px;
    left: 160px;
    opacity: 0;
  }
  .jump {
    width: 180px;
    height: 20px;
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    top: 118px;
    left: 50px;
    opacity: 0;
  }
  .can {
    width: 180px;
    height: 20px;
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    top: 140px;
    left: 50px;
    opacity: 0;
  }
  .nu {
    width: 180px;
    height: 20px;
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    top: 162px;
    left: 50px;
    opacity: 0;
  }
  .fo {
    width: 180px;
    height: 20px;
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    top: 182px;
    left: 50px;
    opacity: 0;
  }
  .break {
    width: 180px;
    height: 20px;
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    top: 50px;
    left: 1058px;
    opacity: 0;
  }
  .piano {
    width: 280px;
    height: 20px;
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    top: 70px;
    left: 1058px;
    opacity: 0;
  }
  .light {
    width: 300px;
    height: 20px;
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    top: 92px;
    left: 1058px;
    opacity: 0;
  }
  .nigula {
    width: 300px;
    height: 20px;
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    top: 114px;
    left: 1058px;
    opacity: 0;
  }
  .flower {
    width: 200px;
    height: 40px;
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    top: 234px;
    left: 1258px;
    opacity: 0;
  }
  .terra {
    width: 210px;
    height: 20px;
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    top: 278px;
    left: 1258px;
    opacity: 0;
  }
  .bread {
    width: 120px;
    height: 40px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 480px;
    left: 210px;
    opacity: 0;
  }
  .lu {
    width: 80px;
    height: 30px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 400px;
    left: 610px;
    opacity: 0;
  }
  .zhou {
    width: 80px;
    height: 30px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 380px;
    left: 740px;
    opacity: 0;
  }
  .bread2 {
    width: 130px;
    height: 30px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 370px;
    left: 880px;
    opacity: 0;
  }
  .jiangshan {
    width: 100px;
    height: 30px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 250px;
    left: 1130px;
    opacity: 0;
  }
  .jiaoyang {
    width: 100px;
    height: 30px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 540px;
    left: 520px;
    opacity: 0;
  }
  .tiane {
    width: 100px;
    height: 30px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 490px;
    left: 900px;
    opacity: 0;
  }
  .bread3 {
    width: 110px;
    height: 30px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 450px;
    left: 1020px;
    opacity: 0;
  }
  .sichou {
    width: 110px;
    height: 30px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 640px;
    left: 590px;
    opacity: 0;
  }
  .zhangqian {
    width: 80px;
    height: 30px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 590px;
    left: 800px;
    opacity: 0;
  }
  .bread4 {
    width: 120px;
    height: 30px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 630px;
    left: 1000px;
    opacity: 0;
  }
  .bread5 {
    width: 120px;
    height: 30px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 760px;
    left: 380px;
    opacity: 0;
  }
  .out {
    width: 80px;
    height: 10px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 790px;
    left: 580px;
    opacity: 0;
  }
  .river {
    width: 90px;
    height: 10px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 810px;
    left: 580px;
    opacity: 0;
  }
  .red {
    width: 140px;
    height: 10px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 860px;
    left: 770px;
    opacity: 0;
  }
  .pina {
    width: 140px;
    height: 10px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 880px;
    left: 770px;
    opacity: 0;
  }
  .chai {
    width: 140px;
    height: 30px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 900px;
    left: 770px;
    opacity: 0;
  }
  .big {
    width: 150px;
    height: 20px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 850px;
    left: 940px;
    opacity: 0;
  }
  .changan {
    width: 150px;
    height: 20px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 872px;
    left: 940px;
    opacity: 0;
  }
  .qin {
    width: 150px;
    height: 20px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 896px;
    left: 940px;
    opacity: 0;
  }
  .hua {
    width: 120px;
    height: 20px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 740px;
    left: 1180px;
    opacity: 0;
  }
  .cul {
    width: 130px;
    height: 40px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 762px;
    left: 1180px;
    opacity: 0;
  }
  .suiyue {
    width: 120px;
    height: 30px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 930px;
    left: 1140px;
    opacity: 0;
  }
  .bread6 {
    width: 130px;
    height: 30px;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 880px;
    left: 330px;
    opacity: 0;
  }
  .btn {
    position: fixed;
    bottom: 20px;
    right: 20px;
    text-align: center;
    background-color: #fff;
    border: 1px solid #fff;
    padding: 5px 20px;
    border-radius: 10px;
  }
}
</style>
